export function renderPersonaDescription(personas: string[]): string {
  const concatenated = personas.join("|");

  switch (concatenated) {
    case "Brand":
      return "Catch off-brand colors, layouts, icons, and other visual discrepancies.";
    case "Copy":
      return "Get feedback on spelling, grammar, clarity, and brand voice.";
    case "Legal":
      return "Review claims, trademarks, disclosures, and other compliance issues.";
    case "Brand|Copy":
      return "Find mistakes and suggested enhancements in both visuals and text.";
    case "Brand|Legal":
      return "Identify non-compliance with either brand or legal guidelines.";
    case "Copy|Legal":
      return "Analyze copy editing as well as potential legal risks.";
    case "Brand|Copy|Legal":
      return "Provide a comprehensive assessment of all potential problems and improvements.";
    default:
      return "";
  }
}
